<template>
  <el-select
    ref="advanceSelectRef"
    :value="innerValue"
    :placeholder="placeholderVal"
    :filterable="filterable||allowCreate"
    :allow-create="allowCreate"
    :disabled="disabled"
    :clearable="clearable"
    @input="onInput"
    @clear="onClear"
    @change="onChange"
    @visible-change="onVisibleChange"
  >
    <el-option
      v-for="(item,index) in options"
      :key="index"
      :label="getLabel(item)"
      :value="item[valueField]"
      :disabled="isForbitOption(item[valueField])"
    />
  </el-select>
</template>

<script>
export default {
  name: 'CargoComboBox',
  props: {
    placeholderVal: { type: [String], default: '' },
    value: { type: [String, Number, Boolean], required: true },
    filterable: { type: Boolean, default: false },
    clearable: { type: Boolean, default: false },
    allowCreate: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    options: { type: Array, default: () => [] },
    labelField: { type: String, default: '' },
    labelFunction: { type: Function, default: null },
    valueField: { type: String, required: true },
    needOldValue: { type: Boolean, default: false }, // 下拉框没取到则保留原值，默认不保留
    forbidValues: { type: Array, default: () => [] }
  },
  data() {
    return {
      innerValue: ''
    }
  },
  watch: {
    value(newVal) {
      if (newVal !== (this.innerValue || '')) {
        this.matchValue()
      }
    },
    disabled(newVal) {
      if (!newVal) {
        this.onInput(this.innerValue || '')
      }
    },
    allowCreate() {
      this.matchValue()
    },
    options() {
      this.matchValue()
    }
  },
  created() {
    this.matchValue()
  },
  methods: {
    matchValue() {
      if (this.allowCreate) {
        this.innerValue = this.value
      } else {
        const options = this.options.filter(p => !this.isForbitOption(p[this.valueField]))
        if (options.length === 0) {
          this.innerValue = null
        } else {
          const option = options.find(p => p[this.valueField] === this.value)
          if (option) {
            this.innerValue = this.value
          } else {
            this.innerValue = options[0][this.valueField]
          }
        }
      }
      if (!this.disabled && !this.needOldValue) {
        this.onInput(this.innerValue || '')
      }
    },
    getLabel(item) {
      if (this.labelFunction) {
        return this.labelFunction(item)
      } else {
        return item[this.labelField] || ' '
      }
    },
    isForbitOption(val) {
      return this.forbidValues && this.forbidValues.includes(val)
    },
    onInput(val) {
      this.$emit('input', val)
    },
    onClear(val) {
      this.$emit('clear', val)
    },
    onChange(val) {
      this.$emit('change', val)
    },
    onVisibleChange(e) {
      if (e) {
        this.setSelectedLabel()
      }
      this.$emit('visible-change', e)
    },
    setSelectedLabel() {
      if (this.allowCreate) {
        this.$nextTick(() => {
          const select = this.$refs.advanceSelectRef
          if (select.query) {
            select.selectedLabel = select.query
          }
        })
      }
    }
  }
}
</script>

<style>
</style>
